import React from 'react';
import { fireSegmentEvent } from '../../../utils';
import { smoothScroll } from '../../Shared/SmokeyTransitional/utils/utils';
import HouseSmartStickyNavStyles from './HouseSmartStickyNav.styled';
import BudgetSmartFull from './icons/BudgetSmartFull.svg';
import BuiltSmartFull from './icons/BuiltSmartFull.svg';
import DesignSmartFull from './icons/DesignSmartFull.svg';
import EnergySmartFull from './icons/EnergySmartFull.svg';

export const HouseSmartStickyNav = ({
  hasTransitionedIn,
  inView,
  pageHasLoaded,
}) => {
  return (
    <HouseSmartStickyNavStyles>
      <ul
        className={`navbar ${inView ? 'visible' : 'not-visible'} ${
          pageHasLoaded ? 'page-loaded' : 'not-loaded'
        }`}
      >
        <li
          className="ga-housesmart-sticky-builtsmart"
          onClick={() => {
            smoothScroll('#BuiltSmart', 0) +
              fireSegmentEvent('CTA Clicked', {
                isNav: false,
                type: 'button',
                text: '',
                eventContext: 'housesmart_sticky_nav_builtsmart',
              });
          }}
        >
          <img className="icon" src={BuiltSmartFull} alt={'builtsmart icon'} />
        </li>
        <li
          className="ga-housesmart-sticky-designsmart"
          onClick={() => {
            smoothScroll('#DesignSmart', 0) +
              fireSegmentEvent('CTA Clicked', {
                isNav: false,
                type: 'button',
                text: '',
                eventContext: 'housesmart_sticky_nav_designsmart',
              });
          }}
        >
          <img
            className="icon"
            src={DesignSmartFull}
            alt={'designsmart icon'}
          />
        </li>
        <li
          className="ga-housesmart-sticky-energysmart"
          onClick={() => {
            smoothScroll('#EnergySmart', 0) +
              fireSegmentEvent('CTA Clicked', {
                isNav: false,
                type: 'button',
                text: '',
                eventContext: 'housesmart_sticky_nav_energysmart',
              });
          }}
        >
          <img
            className="icon"
            src={EnergySmartFull}
            alt={'energysmart icon'}
          />
        </li>
        <li
          className="ga-housesmart-sticky-budgetsmart"
          onClick={() => {
            smoothScroll('#BudgetSmart', 0) +
              fireSegmentEvent('CTA Clicked', {
                isNav: false,
                type: 'button',
                text: '',
                eventContext: 'housesmart_sticky_nav_budgetsmart',
              });
          }}
        >
          <img
            className="icon"
            src={BudgetSmartFull}
            alt={'budgetsmart icon'}
          />
        </li>
      </ul>
    </HouseSmartStickyNavStyles>
  );
};

export default HouseSmartStickyNav;
